import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
export function AssessmentTransitionPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const handleContinue = () => {
    const nextRoute = location.state?.nextRoute || '/assessment/self';
    navigate('/assessment/quiz', {
      state: {
        nextRoute
      }
    });
  };
  return <div className="w-full min-h-screen bg-[#f5f5f7] flex flex-col" data-id="element-703" data-mp="2cv313iknmio7">
      {/* Top bar */}
      <div className="w-full px-5 pt-4 pb-2" data-id="element-704" data-mp="27ych4k5qb2xi">
        <div className="max-w-md mx-auto flex items-center gap-4" data-id="element-705" data-mp="27vgo9a8qn4fx">
          <Link to="/assessment/goals" className="flex items-center justify-center w-10 h-10 -ml-2 text-gray-500 hover:text-[#631bb7] transition-colors" aria-label="Go back" data-id="element-706" data-mp="22wn81a22gzc2">
            <ArrowLeftIcon size={22} data-id="element-707" data-mp="rgym8m0ju6cu" />
          </Link>
          {/* Progress bar */}
          <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-708" data-mp="minag5qp1lrz">
            <div className="h-full bg-[#631bb7] rounded-full transition-all duration-500" style={{
            width: '30%'
          }} data-id="element-709" data-mp="24h0xf9kndkm4" />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 px-5 pt-4 pb-6 flex flex-col" data-id="element-710" data-mp="1zh4t1981fr61">
        <div className="max-w-md mx-auto text-center flex-1 flex flex-col" data-id="element-711" data-mp="1zfjyvkpmya8p">
          <div className="flex-1 flex flex-col items-center justify-center" data-id="element-712" data-mp="1lp83ncxr7vdc">
            <img src="https://cdn.magicpatterns.com/uploads/qm8eGpXKnKzyXLYb5H58w8/Caveo_Icon_Mark_48x39_Full_Color_PNG.png" alt="Caveo" className="w-12 h-auto mx-auto mb-4" data-id="element-713" data-mp="1qgyj1xbjt9bm" />
            <h1 className="md:text-[26px] text-[22px] font-[600] text-[#190647] mb-3" data-id="element-714" data-mp="1grez0oc3n9f6">
              Nice work!
            </h1>
            <p className="text-gray-500 text-sm md:text-base leading-relaxed mb-6" data-id="element-715" data-mp="12ti03la6aqxc">
              Having a good understanding of who you are and what your goals are
              will allow us to not only provide a valuable risk assessment, but
              show how you specifically can achieve your goals with Caveo.
            </p>
            <p className="text-gray-500 text-base md:text-lg leading-relaxed" data-id="element-716" data-mp="2zp1q14ormrbt">
              Now let's dive into the first topic area: <br data-id="element-717" data-mp="2urt8n6bfyrbm" />
              <span className="inline-flex items-center gap-1.5 mt-2 text-[#190647] font-[600]" data-id="element-718" data-mp="2usbf0vrtilx9">
                🏠 Home Wi-Fi Network
              </span>
            </p>
          </div>

          <div className="mt-auto pt-4" data-id="element-719" data-mp="3nfp304djg758">
            <button onClick={handleContinue} className="w-full py-3.5 rounded-xl font-semibold text-white bg-[#631bb7] hover:bg-[#521099] transition-all shadow-md" data-id="element-720" data-mp="3ig2q5w1mgswy">
              Let's Continue
            </button>
          </div>
        </div>
      </div>
    </div>;
}